import { apiClient } from "./ApiClient";
import { IVehicle } from "../classes/Domain";

export default class VehiclesApiClient {

    getVehicleMakes(year: number, quoteId: number, quoteUid: string) {
        return apiClient.instance.request({
            url: '/quote/vehicle/get-makes',
            data: {
                year: year,
                quoteId: quoteId,
                quoteUid: quoteUid
            }
        });
    }

    getVehicleModels(year: number, make: string, quoteUid: string) {
        return apiClient.instance.request({
            url: '/quote/vehicle/get-models',
            data: {
                year: year,
                make: make,
                quoteUid: quoteUid
            }
        });
    }

    getVinRecords(year: number, make: string, model: string, quoteUid: string) {
        return apiClient.instance.request({
            url: '/quote/vehicle/get-vin-records',
            data: {
                year: year,
                make: make,
                model: model,
                quoteUid: quoteUid
            }
        });
    }

    //updateVehicles(vehicle: IVehicle) {
    //    return apiClient.instance.request({
    //        url: '/quote/update-vehicles',
    //        data: vehicle
    //    });
    //}

    updateVehicle(quoteUid: string,  vehicle: IVehicle, quoteStep : string) {
        return apiClient.instance.request({
            url: '/quote/update-vehicle',
            data: {
                quoteUid,
                vehicle,
                quoteStep
            }
        });
    }    
}